import { createFeatureSelector } from '@ngrx/store';

export const cartState = createFeatureSelector<OLO.State.Cart>('cart');
